import React from 'react';

const Portfolio = () => {
  return (
    <div id="portfolio">
      <div className="container">
        <h1 className="subtitle">My Work</h1>
        <div className="work-list">
          <div className="work">
            <img src="images/work1.jpeg" alt="Web Development" />
            <div className="layer">
              <h3>Web Development</h3>
              <p>All of my Web Development work for you</p>
              <a href="#"><i className="fa-solid fa-link"></i></a>
            </div>
          </div>
          <div className="work">
            <img className="work2" src="images/work4.jpeg" alt="SEO" />
            <div className="layer">
              <h3>Search Engine Optimization</h3>
              <p>Sites I worked with on SEO</p>
              <a href="#"><i className="fa-solid fa-link"></i></a>
            </div>
          </div>
          <div className="work">
            <img src="images/work5.jpeg" alt="Writing" />
            <div className="layer">
              <h3>Technical Writing</h3>
              <p>All of my published articles and sites I've worked with</p>
              <a href="#"><i className="fa-solid fa-link"></i></a>
            </div>
          </div>
        </div>
        <a href="#" className="btn">See More</a>
      </div>
    </div>
  );
};

export default Portfolio;
